import AppRoutes from "AppRoutes";
import { NavigationModel } from "models/NavigationModel";
import { TranslationLabels } from "translations/TranslationLabels";

export function getMainNavItems(
  i18n: TranslationLabels,
  pathname: string,
  isAdministrator: boolean,
  isBoardOwner: boolean
): NavigationModel[] {
  const items: NavigationModel[] = [
    {
      text: i18n.Home,
      iconStart: <i className="ms-Icon ms-Icon--Home" />,
      isSelected: pathname === AppRoutes.Home,
      href: AppRoutes.Home,
    },
  ];

  items.push({
    text: i18n.Boards,
    isSelected: pathname.startsWith(AppRoutes.toBoards()),
    href: AppRoutes.toBoards(),
    disabled: !isAdministrator && !isBoardOwner,
  });

  if (isAdministrator) {
    items.push({
      text: "Admin",
      isSelected: false,
      iconStart: <i className="ms-Icon ms-Icon--Admin" />,
      children: [
        {
          text: i18n.Page_Administration_Title,
          href: AppRoutes.getBackendUrl("/admin"),
          isSelected: false,
        },
        {
          text: i18n.Page_Boards_Title,
          href: AppRoutes.toBoards(),
          isSelected: pathname == AppRoutes.Boards,
        },
        {
          text: i18n.Page_Users_Title,
          href: AppRoutes.getBackendUrl("/admin/users"),
          isSelected: false,
        },
        {
          text: i18n.Page_Groups_Title,
          href: AppRoutes.getBackendUrl("/admin/groups"),
          isSelected: false,
        },

        null,

        {
          text: i18n.Page_Translations_Title,
          href: AppRoutes.getBackendUrl("/admin/resources"),
          isSelected: false,
        },
        {
          text: i18n.Page_JobStatus_Title,
          href: AppRoutes.getBackendUrl("/admin/jobs"),
          isSelected: false,
        },
        {
          text: i18n.Page_Mails_Title,
          href: AppRoutes.getBackendUrl("/admin/mails"),
          isSelected: false,
        },

        null,

        {
          text: i18n.Page_Cache_Title,
          href: AppRoutes.getBackendUrl("/admin/cache"),
          isSelected: false,
        },
        {
          text: i18n.Page_StaticCache_Title,
          href: AppRoutes.getBackendUrl("/admin/static-cache"),
          isSelected: false,
        },

        null,

        {
          text: i18n.Page_Memory_Title,
          href: AppRoutes.getBackendUrl("/admin/memory"),
          isSelected: false,
        },
      ],
    });
  }

  return items;
}
